import Box from '@mui/material/Box';
import { useFormikContext } from 'formik';
import type { ReactElement } from 'react';

import type { QuoteFormikType } from '@core/formik/quote';
import { SetFormikValue } from '@core/utils/formikHelpers';
import { Switch } from '@web/components/Switch/Switch';

export const DispatchProductRestrictionsSection = (): ReactElement => {
  const formikBag = useFormikContext<QuoteFormikType>();

  const handleMutuallyExclusiveToggle = (
    field: 'restrictOrdersToProjectProducts' | 'restrictOrdersToProjectMixProducts',
    checked: boolean,
  ): void => {
    const toUncheck =
      field === 'restrictOrdersToProjectProducts'
        ? 'restrictOrdersToProjectMixProducts'
        : 'restrictOrdersToProjectProducts';
    if (checked) {
      // When activating this switch, deactivate the other one
      SetFormikValue(formikBag, field, true);
      SetFormikValue(formikBag, toUncheck, false);
    } else {
      // Just deactivate this switch
      SetFormikValue(formikBag, field, false);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Switch
        checked={formikBag.values.restrictOrdersToProjectProducts}
        label='Restrict to Project Products'
        onChange={(_, checked): void =>
          handleMutuallyExclusiveToggle('restrictOrdersToProjectProducts', checked)
        }
      />
      <Switch
        checked={formikBag.values.restrictOrdersToProjectMixProducts}
        label='Restrict to Project Mixes'
        onChange={(_, checked): void =>
          handleMutuallyExclusiveToggle('restrictOrdersToProjectMixProducts', checked)
        }
      />
    </Box>
  );
};
